import { render, staticRenderFns } from "./SectionSlider.vue?vue&type=template&id=ebbe7dbc&scoped=true&"
import script from "./SectionSlider.vue?vue&type=script&lang=js&"
export * from "./SectionSlider.vue?vue&type=script&lang=js&"
import style0 from "./SectionSlider.vue?vue&type=style&index=0&id=ebbe7dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbe7dbc",
  null
  
)

export default component.exports